export namespace MultiSelectFieldsNS {
    export const MultiSelectFields = {
        leadtypesname: 'leadtypesname',
        opportunity_stage: 'opportunity_stage',
        stagename: 'stagename',
        previousstage: 'previousstage',
        currentstage: 'currentstage',
        leadsstatus: 'leadsstatus',
        industryname: 'industryname',
        opportunity_source: 'opportunity_source',
        sourcename: 'sourcename',
        employeesrangename: 'employeesrangename',
        annualrevenuename: 'annualrevenuename',
        timezonename: 'timezonename',
        currencyname: 'currencyname',
        ownershipname: 'ownershipname',
        ratingname: 'ratingname',
        title: 'title',
        jobfunction: 'jobfunction',
        city: 'city',
        state: 'state',
        trans_location_city: 'trans_location_city',
        trans_location_state: 'trans_location_state',
        trans_billing_city: 'trans_billing_city',
        trans_billing_state: 'trans_billing_state',
        trans_shipping_city: 'trans_shipping_city',
        trans_address_city: 'trans_address_city',
        trans_shipping_state: 'trans_shipping_state',
        trans_address_state:'trans_address_state',
        opportunity_state: 'opportunity_state',
        opportunity_city: 'opportunity_city',
        accounttypesname: 'accounttypesname',
        classificationame: 'classificationame',
        warehouseid: 'warehouseid',
        trans_paymentterm: 'trans_paymentterm',
        paymenttermid: 'paymenttermid',
        paymenttermname: 'paymenttermname',
        trans_paymentmethod: 'trans_paymentmethod',
        paymentmethodid: 'paymentmethodid',
        trans_shippingterm: 'trans_shippingterm',
        shippingtermid: 'shippingtermid',
        trans_shippingmethod: 'trans_shippingmethod',
        shippingmethodid: 'shippingmethodid',
        currencyunitid: 'currencyunitid',
        discounttypeid: 'discounttypeid',
        taxtypeid: 'taxtypeid',
        estimatestatusid: 'estimatestatusid',
        trans_item_item: 'trans_item_item',
        item: 'item',
        trans_transactiontype: 'trans_transactiontype',
        trans_orderstatus: 'trans_orderstatus',
        orderstatusid: 'orderstatusid',
        trans_paymentstatus: 'trans_paymentstatus',
        paymentstatusid: 'paymentstatusid',
        shipmentstatusid: 'shipmentstatusid',
        addressclassid: 'addressclassid',
        addresstypeid: 'addresstypeid',
        trans_addressclass: 'trans_addressclass',
        trans_addresstype: 'trans_addresstype',
        opportunity_addressclass: 'opportunity_addressclass',
        opportunity_addresstype: 'opportunity_addresstype',
        territorycontact: 'territorycontact',
        territoryothercontact: 'territoryothercontact',
        type: 'type',
        logtype: 'logtype',
        logsubtype: 'logsubtype',
        tags: 'tags',
        completionstatus: 'completionstatus',
        taskcategory: 'taskcategory',
        priority: 'priority',
        status: 'status',
        taskstatus: 'taskstatus',

    } as const;

    export const MultiSelectFieldsArray = [
        'leadtypesname',
        'opportunity_stage',
        'stagename',
        'currentstage',
        'previousstage',
        'leadsstatus',
        'industryname',
        'industry',
        'opportunity_source',
        'sourcename',
        'employeesrangename',
        'noofemployees',
        'annualrevenuename',
        'estimatedannualrevenue',
        'timezonename',
        'timezone',
        'currencyname',
        'currency',
        'ownershipname',
        'ownershiptype',
        'ratingname',
        'title',
        'trans_sales_rep_gender',
        'trans_created_by_gender',
        'gender',
        'jobfunction',
        'languagespoken',
        'vendortype',
        'businessclassification',
        'trans_location_city',
        'trans_location_state',
        'trans_billing_state',
        'trans_shipping_state',
        'trans_billing_city',
        'trans_shipping_city',
        'trans_address_city',
        'trans_address_state',
        'opportunity_city',
        'opportunity_state',
        'city',
        'state',
        'accounttypesname',
        'classificationame',
        'warehouseid',
        'paymenttermname',
        'trans_paymentterm',
        'paymenttermid',
        'paymentterm',
        'preferredpaymentterm',
        'trans_paymentmethod',
        'payterm',
        'paymethod',
        'paymentmethodid',
        'paymentmethod',
        'preferredpaymentmethod',
        'trans_shippingterm',
        'shippingtermid',
        'trans_shippingmethod',
        'shippingmethodid',
        'shippingmethod',
        'preferredshippingmethod',
        'currencyunitid',
        'discounttypeid',
        'trans_total_discount_discountby',
        'trans_item_discount_discountby',
        'transactionlinehandlingfeesfeetype',
        'transactionhandlingfeesfeetype',
        'transactionhandlingfeesname',
        'transactionlinehandlingfeesname',
        'trans_item_discount_name',
        'trans_total_discount_name',
        'taxtypeid',
        'estimatestatusid',
        'trans_estimatestatus',
        'trans_item_item',
        'item',
        'trans_orderstatus',
        'orderstatusid',
        'trans_paymentduestatus',
        'trans_billstatus',
        'trans_paymentstatus',
        'paymentstatusid',
        'shipmentstatusid',
        'trans_deliverystatus',
        'opportunity_item_itemno',
        'productname',
        'opportunity_quality',
        'quality',
        'salesorderstatusid',
        'salesorderstageid',
        'trans_orderstage',
        'taxid',
        'brandid',
        'trans_item_product_brand',
        'trans_item_product_itemtype',
        'lwhunitofmeasurementid',
        'trans_item_product_lwhuom',
        'trans_item_product_wuom',
        'manufacturerid',
        'trans_item_product_manufacturer',
        'productownerid',
        'visibility',
        'typeid',
        'variant',
        'trans_item_product_variant',
        'vendorid',
        'trans_item_product_preferredvendor',
        'wunitofmeasuremetid',
        'taxable',
        'opportunity_forecastcategory',
        'forcastcategory',
        'addressclassid',
        'addresstypeid',
        'trans_addressclass',
        'trans_addresstype',
        'opportunity_addressclass',
        'opportunity_addresstype',
        'territorycontact',
        'territoryothercontact',
        'type',
        'logtype',
        'logsubtype',
        'tags',
        'trans_location',
        'trans_location_locationname',
        'trans_location_locationid',
        'trans_location_type',
        'trans_location_group',
        'trans_location_category',
        'locationtype',
        'locationgroup',
        'locationcategory',
        'trans_salesrep',
        'lastinvoicesalesrep',
        'lastordersalesrep',
        'trans_created_by_role',
        'trans_created_by_jobtype',
        'trans_created_by_department',
        'trans_created_by_workinglocation',
        'trans_sales_rep_role',
        'trans_sales_rep_jobtype',
        'trans_sales_rep_department',
        'trans_sales_rep_workinglocation',
        'trans_updated_by_role',
        'trans_updated_by_jobType',
        'trans_updated_by_department',
        'trans_updated_by_workinglocation',
        'activeinactivestatus',
        'contactactiveinactivestatus',
        'relationtype',
        'completionstatus',
        'taskcategory',
        'priority',
        'status',
        'taskstatus',
        'trans_postatus',
        'trans_billpaymentstatus',
        'trans_vrmastatus',
        'trans_vendorcreditstatus',
        'stage',
        'addresstype',
        'trans_address_type',
        'isactive',
        'shippingterm',
        'billpaymentstatus',
        'billstatus',
        'payment',
        'trans_aging_stage',
        'contact_roles',
        'requesttype',
        'reason',
        'returnfromlocation'
    ];

    export const TreeSelectFieldsArray = [
        'territoryname',
        'assetaccountid',
        'trans_item_product_assetaccount',
        'cogsaccountid',
        'trans_item_product_cogsaccount',
        'incomeaccountid',
        'trans_item_product_incomeaccount',
        'classid',
        'trans_item_product_class',
        'category',
        'trans_item_product_category',
        'uom',
        'trans_item_uom',
        'opportunity_item_uom',
        'trans_item_product_uom',
        'trans_shippingmethod',
        'shippingmethodid',
        'shippingmethod',
        'preferredshippingmethod',
        'trans_item_expenseaccount',
        'trans_discountaccount',
        'billfinancialaccount',
        'class'
    ];

    export const MultiSelectAPIFieldsArray = [
        'accountid',
    ];

    export const AutoCompleteDropdownFieldsArray = [
        'associationname',
        'businessname',
        'opportunity_accountname',
        'accountname',
        'accountid',
        'maincustomer',
        'name',
        'vendorname',
        'locationname',
        'association',
        'taskid',
        'trans_item_product_itemno',
        'vendor',
        // 'account'
        'trans_prod_account',
        'trans_prod_vendor'
    ];

    export const AutoCompleteProductFieldsArray = [
        'itemno',
        'manufacturerpartno',
        'vendorsku',
        'trans_item_product_vendorsku',
        'serialnobarcode',
        'trans_item_product_barcode',
        'revisionnumber',
        'lotnumber',
        'opportunity_item_itemno',
        'productname'
    ];

    export const UserFieldsArray = [
        'createdby',
        'createdbyusername',
        'contactcreatedby',
        'updatedby',
        'contactupdatedby',
        'updatedbyusername',
        'lastupdatedby',
        'userid',
        'owner',
        'ownername',
        'currentstageowner',
        'previousstageowner',
        'stagechangedby',
        'productownerid',
        'opportunity_owner',
        'territoryupdatedby',
        'territorycreatedby',
        'trans_createdby',
        'trans_updatedby',
        'opportunity_createdby',
        'opportunity_updatedby',
        'trans_salesrep',
        'lastinvoicesalesrep',
        'lastordersalesrep',
        'trans_location_contactperson',
        'assignedto',
        'sharedwith',
        'reassignto',
        'salesrep',
        'bpcreatedby',
        'bpupdatedby',
        'vcupdatedby',
        'vccreatedby',
        'vrmaupdatedby'
    ];

    export const DropdownFieldsArray = [
        'associatedmodulename',
        'associatedchannelname',
        'channel',
        'relatedto',
        'tasktype',
        'trans_transactiontype',
        // 'transactionaction',
        // 'transactiontype'
        'trans_prod_transaction_type',
        'trans_prod_transaction_action'

    ]

    export type typeMultiSelectFields = typeof MultiSelectFields[keyof typeof MultiSelectFields];
    export const valueMultiSelectFields = Object.values(MultiSelectFields);
}
